<template>
  <page-content v-if="hasPermission('package_view')">
    <panel title="Thông tin tìm kiếm">
      <c-form ref="searchForm" @submit="search()">

        <b-row>
          <c-input v-model="formSearch.packageOrdersStr"
                   form-group-class="col-6"
                   label="Package order"
                   placeholder='Danh sách đơn hàng (Ngăn cách bằng dấu ",")'
                   validate-rules=""/>


          <c-select2 v-model="formSearch.isCreateBill"
                     label="Trạng thái tạo phiếu"
                     form-group-class="col-6"
          >
            <option value="false" selected>Chưa tạo phiếu</option>
            <option value="true">Đã tạo phiếu</option>
          </c-select2>


        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>

          </b-col>
        </b-row>
      </c-form>
    </panel>

    <panel title="Kết quả tìm kiếm">
      <c-table ref="table"
               :data-filter="dataSearch"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'package_order', sortField:'packageOrder', sortable: true},
                   {text: 'is_create_bill', sortField:'isCreateBill', sortable: true},
                   {text: 'created_at', sortField:'createdAt', sortable: true},
                   {text: 'updated_at', sortField:'updatedAt', sortable: true},
                   {text: 'Thao tác', width: '150px'},
               ]"
               uri="/cms/api/v1.0/package/get"
      >
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.packageOrder }}</td>
          <td>{{ item.isCreateBill }}</td>
          <td>{{ item.createdAt | datetime }}</td>
          <td>{{ item.updatedAt | datetime }}</td>
          <td class="text-center">
            <b-button
                v-if="!item.isCreateBill && hasPermission('package_create')"
                class="btn btn-icon"
                title="Tạo phiếu"
                type="button"
                variant="success"
                @click="packageProducer(item)"
            >
              <i class="fas fa-file-invoice"></i>
            </b-button>
          </td>
        </template>
      </c-table>
    </panel>
  </page-content>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      formSearch: {
        packageOrdersStr: null,
        isCreateBill: 'false'
      },
    }
  },
  computed:{
    dataSearch(){
      return {
        isCreateBill: this.formSearch.isCreateBill,
        packageOrders: this.formSearch.packageOrdersStr ? this.formSearch.packageOrdersStr.split(',').map(x => x.trim()) : []
      }
    }
  },
  methods: {
    search() {
      this.$refs.table.reload();
    },
    packageProducer(packageInfo) {
      this.$http.post(
          '/package-service/v1.0/kafka/producer',
          {
            "package_status_id": packageInfo.packageStatusId,
            "pick_address": packageInfo.pickAddress,
            "pick_address_id": packageInfo.pickAddressId,
            "pkg_order": packageInfo.packageOrder,
            "request_date": packageInfo.requestDate,
            "shop_id": packageInfo.shopId
          }
      ).then(res => {
        this.$success();
        this.search();
      }).catch(err => {
        this.errorNotify(err);
      })
    },
  },
}
</script>

<style scoped>

</style>